import type { ToastMessageOptions } from 'primevue/toast'
import ToastEventBus from 'primevue/toasteventbus'

function addToast(data: ToastMessageOptions) {
  ToastEventBus.emit('add', data)
}

export const useAppToast = () => {
  const showErrorToast = (summary: string, detail: string) => {
    addToast({
      summary,
      detail,
      severity: 'error',
      life: 3000
    })
  }

  const showSuccessToast = (summary: string, detail: string) => {
    addToast({
      summary,
      detail,
      severity: 'success',
      life: 3000
    })
  }

  return {
    showErrorToast,
    showSuccessToast
  }
}

/** For axios interceptors and other code outside component `setup` */
export const showErrorToastGlobal = (summary: string, detail: string) => {
  addToast({
    summary,
    detail,
    severity: 'error',
    life: 3000
  })
}
